import { Component, computed, inject, input } from '@angular/core'
import { rxResource } from '@angular/core/rxjs-interop'
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome'
import { of } from 'rxjs'
import { PublicService } from 'src/app/public/services/public.service'

@Component({
    selector: 'sf-payment-cancel',
    imports: [FontAwesomeModule],
    templateUrl: './payment-cancel.component.html',
    styleUrl: './payment-cancel.component.scss',
})
export class PaymentErrorComponent {
    #publicService = inject(PublicService)

    companyId = input<number>()

    #companyResource = rxResource({
        params: () => this.companyId(),
        stream: ({ params }) => {
            if (!params) {
                return of(null)
            }
            return this.#publicService.getCompanyDetails(params)
        },
    })

    company = computed(() => this.#companyResource.value())
}
